import type {
  ClaimRow,
  ProcedureRow,
  ProcedureItemRow,
} from './AttachToClaimsModal.component'

export const MOCK_CLAIMS: ClaimRow[] = [
  {
    id: 'C12345',
    dateSubmitted: '12/1/2026',
    patientName: 'John Doe',
    carrier: 'ABC Insurance',
    status: 'Under Review',
  },
  {
    id: 'C12346',
    dateSubmitted: '12/5/2026',
    patientName: 'Jane Doe',
    carrier: 'XYZ Insurance',
    status: 'Approved',
  },
  {
    id: 'C12347',
    dateSubmitted: '12/10/2026',
    patientName: 'Mark Johnson',
    carrier: 'Delta Dental',
    status: 'Rejected',
  },
  {
    id: 'C12348',
    dateSubmitted: '12/12/2026',
    patientName: 'Sarah Lee',
    carrier: 'Guardian',
    status: 'Draft',
  },
]

export const MOCK_PROCEDURES_BY_CLAIM: Record<string, ProcedureRow[]> = {
  C12345: [
    {
      id: 'proc-1',
      procedureCode: 'D1140',
      procedureDate: '6/20/2026',
      area: '12/MO',
      claimAmt: '$20.00',
      selectActive: false,
    },
    {
      id: 'proc-2',
      procedureCode: 'D1055',
      procedureDate: '6/18/2026',
      area: '3/MO',
      claimAmt: '$45.00',
      selectActive: true,
    },
  ],
  C12346: [
    {
      id: 'proc-3',
      procedureCode: 'D1208',
      procedureDate: '6/22/2026',
      area: '19/MO',
      claimAmt: '$50.00',
      selectActive: true,
    },
  ],
  C12347: [],
  C12348: [],
}

export const MOCK_PROCEDURE_ITEMS: Record<string, ProcedureItemRow[]> = {
  D1140: [
    {
      id: 'item-1',
      itemNo: 1,
      formatType: 'PDF',
      type: 'X-Ray',
      dateTaken: '6/19/2026',
    },
    {
      id: 'item-2',
      itemNo: 2,
      formatType: 'JPG',
      type: 'Photo',
      dateTaken: '6/20/2026',
    },
  ],
  D1055: [
    {
      id: 'item-3',
      itemNo: 1,
      formatType: 'PDF',
      type: 'Document',
      dateTaken: '6/17/2026',
    },
  ],
  D1208: [
    {
      id: 'item-4',
      itemNo: 1,
      formatType: 'PNG',
      type: 'Image',
      dateTaken: '6/21/2026',
    },
  ],
}
